<template>
  <div>
    <p style="text-align: center">
      <span
        style="font-size: 96px; font-family: 'Arial Black', Gadget, sans-serif"
        >{{ applicationName }}</span
      ><span style="font-size: 96px; font-family: Georgia, serif">&nbsp;</span>
    </p>
    <p style="text-align: center">
      <strong
        ><span
          style="
            font-size: 22px;
            font-family: 'Trebuchet MS', Helvetica, sans-serif;
          "
          >Boutique depot-vente</span
        ></strong
      >
    </p>
    <p style="text-align: center">
      <strong
        ><span style="font-family: Verdana, Geneva, sans-serif"
          >Ticket N° {{ numero }}</span
        ></strong
      ><span style="font-size: 22px"
        ><strong
          ><span style="font-family: Verdana, Geneva, sans-serif"
            >&nbsp; Date :&nbsp;{{ date() }}</span
          ></strong
        ></span
      >
    </p>
    <table style="width: 100%">
      <thead>
        <tr>
          <th style="background-color: rgb(0, 0, 0)">
            <span
              style="
                color: rgb(255, 255, 255);
                font-size: 22px;
                font-family: 'Trebuchet MS', Helvetica, sans-serif;
              "
              >Référence&nbsp;</span
            >
          </th>
          <th style="background-color: rgb(0, 0, 0)">
            <span
              style="
                color: rgb(255, 255, 255);
                font-size: 22px;
                font-family: 'Trebuchet MS', Helvetica, sans-serif;
              "
              >Article&nbsp;</span
            >
          </th>
          <th style="background-color: rgb(0, 0, 0)">
            <span style="color: rgb(255, 255, 255)"
              ><strong
                ><span
                  style="
                    font-size: 22px;
                    font-family: 'Trebuchet MS', Helvetica, sans-serif;
                  "
                  >Prix</span
                ></strong
              ></span
            >
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td style="width: 33.3333%; border: solid rgb(15, 15, 15)">
            {{ item.id }}
          </td>
          <td style="width: 33.3333%; border: solid rgb(15, 15, 15)">
            {{ item.name }}
          </td>
          <td style="width: 33.3333%; border: solid rgb(15, 15, 15)">
            {{ item.price }}
          </td>
        </tr>
      </tbody>
    </table>
    <p style="text-align: center">
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      <span style="font-size: 22px"
        ><strong
          >&nbsp;
          <span style="font-family: 'Trebuchet MS', Helvetica, sans-serif"
            >&nbsp; &nbsp;Total :&nbsp;{{ total }} DT</span
          ></strong
        ></span
      >
    </p>
    <p><br /></p>
    <p
      dir="ltr"
      style="
        line-height: 1.44;
        margin-left: 95pt;
        margin-right: 95pt;
        text-align: center;
        margin-top: 5pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 20px;
          font-family: 'Trebuchet MS', Helvetica, sans-serif;
          color: rgb(0, 0, 0);
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre-wrap;
        "
        ><strong
          >**Merci d&rsquo;avoir choisi {{ simplePlateformName }}**</strong
        ></span
      >
    </p>
    <p
      dir="ltr"
      style="
        line-height: 1.44;
        margin-left: 95pt;
        margin-right: 95pt;
        text-align: center;
        margin-top: 5pt;
        margin-bottom: 0pt;
      "
    >
      <span style="font-size: 20px"
        ><span style="font-family: 'Trebuchet MS', Helvetica, sans-serif"
          ><strong
            >Echange sous 48H et uniquement sur présentation de votre ticket de
            caisse</strong
          ></span
        ></span
      >
    </p>
    <p
      dir="ltr"
      style="
        line-height: 1.44;
        margin-left: 95pt;
        margin-right: 95pt;
        text-align: center;
        margin-top: 1pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 20px;
          font-family: 'Trebuchet MS', Helvetica, sans-serif;
          color: rgb(0, 0, 0);
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre-wrap;
        "
        ><strong>{{ appContact }}</strong></span
      >
    </p>
    <div id="gtx-trans" style="position: absolute; left: 448px; top: 321.4px">
      <div class="gtx-trans-icon"><br /></div>
    </div>
  </div>
</template>
<script>
import { Printd } from "printd";
import constants from "@/mixins/constants";
export default {
  mixins: [constants],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    total: {
      type: String,
      default: "0",
    },
    numero: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    date: function () {
      const date = new Date();
      const month = date.getMonth() + 1;
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      return (
        (dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth) +
        "/" +
        (month < 10 ? "0" + month : month) +
        "/" +
        year
      );
    },
    printMe() {
      const d = new Printd();
      d.print(this.$el, [
        `
        table {
    border:solid #000 !important;
    border-width:1px 0 0 1px !important;
}
th, td {
    border:solid #000 !important;
    border-width:0 1px 1px 0 !important;
}
      `,
      ]);
    },
  },
};
</script>
